import { gql } from "@apollo/client";

export const GET_DATA_REQUEST_FEEDBACK = gql`
  query getDataRequestFeedback($user_id: uuid!, $org_id: uuid!) {
    mentors: mentoring(where: { mentee_id: { _eq: $user_id } }) {
      mentor {
        user_id
        email
        role
        name
        updated_at
        created_at
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
    }
    species {
      species_id
      name
    }
    competencySkills: requirement(where: { type: { _eq: "COMPETENCY" } }) {
      requirement_id
      name
      type
      description
      overview
      domains {
        relation
        domain {
          requirement_domain_id
          name
          code
          color_hex
          sort_order
        }
      }
      evaluation_metrics {
        evaluation_metric_id
        skill_level
        description
        target_achievement_time
        skill_level_label
        target_achievement_time_label
      }
    }
    graduation_class_student(
      where: { student: { user_id: { _eq: $user_id } } }
    ) {
      graduation_class {
        current_academic_year {
          requirements {
            requirement {
              requirement_id
              name
              type
              description
              overview
              domains {
                relation
                domain {
                  requirement_domain_id
                  name
                  code
                  color_hex
                  sort_order
                }
              }
              evaluation_metrics {
                evaluation_metric_id
                skill_level
                description
                target_achievement_time
                skill_level_label
                target_achievement_time_label
              }
              competencies {
                competency {
                  requirement_id
                  name
                  type
                  description
                  overview
                  domains {
                    relation
                    domain {
                      requirement_domain_id
                      name
                      code
                      color_hex
                      sort_order
                    }
                  }
                  evaluation_metrics {
                    evaluation_metric_id
                    skill_level
                    description
                    target_achievement_time
                    skill_level_label
                    target_achievement_time_label
                  }
                }
              }
            }
          }
        }
      }
    }
    user(where: { user_id: { _eq: $user_id } }) {
      user_id
      org_id
      name
      email
    }
    organization_site(where: { org_id: { _eq: $org_id } }) {
      org_site_id
      site {
        name
        site_id
        address {
          address_id
          address_line_1
          address_line_2
          city
          state
          country
          zip_code
        }
      }
    }
    tag(where: { type: { _eq: "feedbackFocus" } }) {
      name
      tag_id
      type
    }
  }
`;

export const GET_FEEDBACKS = gql`
  query getFeedbacks {
    feedback {
      feedback_id
      org_id
      student_id
      coach_id
      species_id
      animal_size
      course
      mrn
      status
      note_to_coach
      created_at
      reviewed_at
      observation_date
      animal_sex
      organization {
        org_id
        name
      }
      student {
        user_id
        email
        name
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      coach {
        user_id
        email
        name
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      species {
        name
        species_id
      }
      feedback_skills {
        actions
        areas
        coach_comments
        feedback_skill_id
        note
        requirement {
          name
          requirement_id
          type
          domains {
            relation
            domain {
              requirement_domain_id
              name
              code
              color_hex
              sort_order
            }
          }
          competencies {
            competency {
              requirement_id
              domains {
                relation
                domain {
                  requirement_domain_id
                  name
                  code
                  color_hex
                  sort_order
                }
              }
            }
          }
          evaluation_metrics {
            evaluation_metric_id
            skill_level
            description
            target_achievement_time
            skill_level_label
            target_achievement_time_label
          }
        }
        self_rating
        coach_rating
        student_comments
      }
    }
  }
`;

export const GET_FEEDBACKS_BY_ORGANIZATION_ID = gql`
  query getFeedbacksByOrganizationId($organizationId: uuid!) {
    feedback(where: { org_id: { _eq: $organizationId } }) {
      feedback_id
      org_id
      student_id
      coach_id
      species_id
      animal_size
      mrn
      status
      course
      note_to_coach
      created_at
      reviewed_at
      observation_date
      animal_sex
      organization {
        org_id
        name
      }
      student {
        user_id
        email
        name
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      coach {
        user_id
        email
        name
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      species {
        name
        species_id
      }
      feedback_skills {
        actions
        areas
        coach_comments
        feedback_skill_id
        note
        requirement {
          name
          requirement_id
          type
          description
          overview
          domains {
            relation
            domain {
              requirement_domain_id
              name
              code
              color_hex
              sort_order
            }
          }
          competencies {
            competency {
              requirement_id
              domains {
                relation
                domain {
                  requirement_domain_id
                  name
                  code
                  color_hex
                  sort_order
                }
              }
            }
          }
          evaluation_metrics {
            evaluation_metric_id
            skill_level
            description
            target_achievement_time
            skill_level_label
            target_achievement_time_label
          }
        }
        self_rating
        coach_rating
        student_comments
      }
    }
  }
`;

export const GET_FEEDBACKS_BY_ORGANIZATION_IDS = gql`
  query getFeedbacksByOrganizationIds(
    $organizationIds: [uuid!]!
    $sinceDate: timestamptz!
    $excludeTestOrgNamePattern: String!
  ) {
    feedback(
      where: {
        org_id: { _in: $organizationIds }
        created_at: { _gte: $sinceDate }
        organization: { name: { _nilike: $excludeTestOrgNamePattern } }
      }
    ) {
      feedback_id
      org_id
      student_id
      coach_id
      species_id
      animal_size
      mrn
      status
      course
      note_to_coach
      created_at
      reviewed_at
      observation_date
      animal_sex
      organization {
        org_id
        name
      }
      student {
        user_id
        email
        name
        picture_url
      }
      coach {
        user_id
        email
        name
        picture_url
      }
      species {
        name
        species_id
      }
      feedback_skills {
        actions
        areas
        coach_comments
        feedback_skill_id
        note
        requirement {
          name
          requirement_id
          type
          description
          overview
          domains {
            relation
            domain {
              requirement_domain_id
              name
              code
              color_hex
              sort_order
            }
          }
          competencies {
            competency {
              requirement_id
              domains {
                relation
                domain {
                  requirement_domain_id
                  name
                  code
                  color_hex
                  sort_order
                }
              }
            }
          }
          evaluation_metrics {
            evaluation_metric_id
            skill_level
            description
            target_achievement_time
            skill_level_label
            target_achievement_time_label
          }
        }
        self_rating
        coach_rating
        student_comments
      }
    }
  }
`;

export const GET_FEEDBACKS_BY_STUDENT_ID = gql`
  query getFeedbacksByStudentId($studentId: uuid!) {
    feedback(where: { student_id: { _eq: $studentId } }) {
      feedback_id
      org_id
      student_id
      coach_id
      species_id
      animal_size
      mrn
      status
      course
      note_to_coach
      created_at
      reviewed_at
      observation_date
      animal_sex
      organization {
        org_id
        name
      }
      student {
        user_id
        email
        name
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      coach {
        user_id
        email
        name
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      species {
        name
        species_id
      }
      feedback_skills {
        coach_rating
        actions
        areas
        coach_comments
        feedback_skill_id
        note
        requirement {
          name
          requirement_id
          type
          description
          overview
          domains {
            relation
            domain {
              requirement_domain_id
              name
              code
              color_hex
              sort_order
            }
          }
          competencies {
            competency {
              requirement_id
              domains {
                relation
                domain {
                  requirement_domain_id
                  name
                  code
                  color_hex
                  sort_order
                }
              }
            }
          }
          evaluation_metrics {
            evaluation_metric_id
            skill_level
            description
            target_achievement_time
            skill_level_label
            target_achievement_time_label
          }
        }
        student_comments
      }
    }
  }
`;

export const GET_VALID_FEEDBACKS_BY_STUDENT_ID = gql`
  query getValidFeedbacksByStudentId($studentId: uuid!) {
    feedback(
      where: {
        student_id: { _eq: $studentId }
        status: { _nin: ["DRAFT", "ARCHIVED", "HIDDEN"] }
      }
    ) {
      feedback_id
      org_id
      student_id
      coach_id
      species_id
      animal_size
      mrn
      status
      course
      note_to_coach
      created_at
      reviewed_at
      observation_date
      animal_sex
      organization {
        org_id
        name
      }
      student {
        user_id
        email
        name
      }
      coach {
        user_id
        email
        name
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      species {
        name
        species_id
      }
      feedback_skills {
        actions
        areas
        coach_comments
        feedback_skill_id
        note
        requirement {
          name
          requirement_id
          type
          description
          overview
          domains {
            relation
            domain {
              requirement_domain_id
              name
              code
              color_hex
              sort_order
            }
          }
          competencies {
            competency {
              requirement_id
              domains {
                relation
                domain {
                  requirement_domain_id
                  name
                  code
                  color_hex
                  sort_order
                }
              }
            }
          }
          evaluation_metrics {
            evaluation_metric_id
            skill_level
            description
            target_achievement_time
            skill_level_label
            target_achievement_time_label
          }
        }
        self_rating
        coach_rating
        student_comments
      }
    }
  }
`;

export const GET_VALID_FEEDBACKS_BY_STUDENT_AND_COACH = gql`
  query getValidFeedbacksByStudentAndCoach($studentId: uuid!, $coachId: uuid!) {
    feedback(
      where: {
        student_id: { _eq: $studentId }
        coach_id: { _eq: $coachId }
        status: { _nin: ["DRAFT", "ARCHIVED", "HIDDEN"] }
      }
    ) {
      feedback_id
      org_id
      student_id
      coach_id
      species_id
      animal_size
      mrn
      status
      course
      note_to_coach
      created_at
      reviewed_at
      observation_date
      animal_sex
      organization {
        org_id
        name
      }
      student {
        user_id
        email
        name
      }
      coach {
        user_id
        email
        name
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      species {
        name
        species_id
      }
      feedback_skills {
        actions
        areas
        coach_comments
        feedback_skill_id
        note
        requirement {
          name
          requirement_id
          type
          description
          overview
          domains {
            relation
            domain {
              requirement_domain_id
              name
              code
              color_hex
              sort_order
            }
          }
          competencies {
            competency {
              requirement_id
              domains {
                relation
                domain {
                  requirement_domain_id
                  name
                  code
                  color_hex
                  sort_order
                }
              }
            }
          }
          evaluation_metrics {
            evaluation_metric_id
            skill_level
            description
            target_achievement_time
            skill_level_label
            target_achievement_time_label
          }
        }
        self_rating
        coach_rating
        student_comments
      }
    }
  }
`;

export const GET_FEEDBACKS_BY_COACH_ID = gql`
  query getFeedbacksByCoachId($coachId: uuid!) {
    feedback(where: { coach_id: { _eq: $coachId } }) {
      feedback_id
      org_id
      student_id
      coach_id
      course
      species_id
      animal_size
      mrn
      status
      note_to_coach
      created_at
      reviewed_at
      observation_date
      animal_sex
      organization {
        org_id
        name
      }
      student {
        user_id
        email
        name
      }
      coach {
        user_id
        email
        name
      }
      species {
        name
        species_id
      }
      feedback_skills {
        actions
        areas
        coach_comments
        feedback_skill_id
        note
        requirement {
          name
          requirement_id
          type
          description
          overview
          domains {
            relation
            domain {
              requirement_domain_id
              name
              code
              color_hex
              sort_order
            }
          }
          competencies {
            competency {
              requirement_id
              domains {
                relation
                domain {
                  requirement_domain_id
                  name
                  code
                  color_hex
                  sort_order
                }
              }
            }
          }
          evaluation_metrics {
            evaluation_metric_id
            skill_level
            description
            target_achievement_time
            skill_level_label
            target_achievement_time_label
          }
        }
        self_rating
        coach_rating
        student_comments
      }
    }
  }
`;

export const GET_FEEDBACK_BY_ID = gql`
  query getFeedbackById($feedbackId: uuid!) {
    feedback_by_pk(feedback_id: $feedbackId) {
      animal_size
      animal_name
      animal_sex
      feedback_type
      feedback_id
      org_id
      student_id
      student {
        user_id
        email
        name
        role
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      coach_id
      coach {
        user_id
        email
        name
        role
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      species_id
      species {
        name
        species_id
      }
      course
      mrn

      status
      note_to_coach
      coach_rate
      created_at
      reviewed_at
      observation_date
      animal_sex

      species {
        name
        species_id
      }
      feedback_skills {
        actions
        areas
        coach_comments
        feedback_skill_id
        note
        requirement {
          requirement_id
          name
          type
          description
          overview
          domains {
            relation
            domain {
              requirement_domain_id
              name
              code
              color_hex
              sort_order
            }
          }
          competencies {
            competency {
              requirement_id
              domains {
                relation
                domain {
                  requirement_domain_id
                  name
                  code
                  color_hex
                  sort_order
                }
              }
            }
          }
          evaluation_metrics {
            evaluation_metric_id
            skill_level
            description
            target_achievement_time
            skill_level_label
            target_achievement_time_label
          }
        }
        self_rating
        coach_rating
        student_comments
      }
      site {
        site_id
        name
      }
      tags {
        tag {
          name
          tag_id
          type
        }
        feedback_tag_id
      }

      organization {
        custom_labels {
          custom_label {
            custom_label_id
            index
            label
            type
          }
        }
      }
    }
  }
`;

export const GET_REQUIREMENT_FEEDBACK_STATS_BY_STUDENT_ID = gql`
  query getRequirementFeedbackStatsByStudentId(
    $requirementId: uuid!
    $studentId: uuid!
  ) {
    feedback(
      where: {
        feedback_skills: { requirement_id: { _eq: $requirementId } }
        student_id: { _eq: $studentId }
        status: { _nin: ["DRAFT", "ARCHIVED", "HIDDEN"] }
      }
      order_by: { observation_date: asc }
    ) {
      feedback_id
      course
      observation_date
      student_id
      status
      created_at
      reviewed_at
      coach_id
      coach {
        user_id
        email
        name
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      feedback_skills(where: { requirement_id: { _eq: $requirementId } }) {
        coach_rating
        self_rating
      }
    }
  }
`;

export const GET_REQUIREMENT_FEEDBACK_STATS_BY_STUDENT_AND_COACH = gql`
  query getRequirementFeedbackStatsByStudentAndCoach(
    $requirementId: uuid!
    $studentId: uuid!
    $coachId: uuid!
  ) {
    feedback(
      where: {
        feedback_skills: { requirement_id: { _eq: $requirementId } }
        student_id: { _eq: $studentId }
        coach_id: { _eq: $coachId }
        status: { _nin: ["DRAFT", "ARCHIVED", "HIDDEN"] }
      }
      order_by: { observation_date: asc }
    ) {
      feedback_id
      course
      observation_date
      student_id
      status
      created_at
      reviewed_at
      coach_id
      coach {
        user_id
        email
        name
        picture_url
      }
      feedback_skills(where: { requirement_id: { _eq: $requirementId } }) {
        coach_rating
        self_rating
      }
    }
  }
`;


export const GET_COACH_FEEDBACK_COUNT = gql`
  query getCoachFeedbackCount($coachId: uuid!) {
    feedback(
      where: {
        coach_id: { _eq: $coachId }
        status: { _eq: "DONE" }
      }
    ) {
      feedback_id
    }
  }
`;

export const GET_LEARNER_FEEDBACK_REQUEST_COUNT = gql`
  query getLearnerFeedbackRequestCount($studentId: uuid!) {
    feedback(
      where: {
        student_id: { _eq: $studentId }
      }
    ) {
      feedback_id
    }
  }
`;
